import { ListResponse, PaginationRequest } from './client/types'
import { useAPI } from './client/useAPI'
import { AccountTransaction } from '../../lib/types/AccountTransaction'

export type TransactionListItem = AccountTransaction

export type TransactionsRequest = PaginationRequest & {
  companyId?: string
  createdAtFrom?: string
  createdAtTo?: string
}

type TransactionsResponse = ListResponse<TransactionListItem>

export const useTransactions = () => {
  return useAPI<TransactionsResponse, TransactionsRequest>(
    'GET',
    '/transactions',
    {
      withToken: true,
    }
  )
}
